export default {
  title: 'No data in the system yet',
  employees: {
    couriers: {
      title: 'No couriers in system yet',
      subtitle: 'Add new employees and start manage process',
    },
    managers: {
      title: 'No area managers in system yet',
      subtitle: 'Add new employees and start manage process',
    },
    admins: {
      title: 'No admins in system yet',
      subtitle: 'Add new employees and start manage process',
    },
  },
  journeys: {
    title: 'No journeys in system yet',
  },
  routes: {
    title: 'No routes in system yet',
    subtitle: 'Add new route and start manage process',
  },
  leaves: {
    title: 'No leaves in system yet',
  },
}
